
(function ($) {
  const openClass = 'is-open';
  const activeClass = 'is-active';
  const toggleClass = 'js-nav-toggle';

  const $header = $('.js-header');
  const $mainNav = $('.js-navbar-main');
  const $navHamburger = $('.js-navbar-hamburger');
  const $navToggles = $mainNav.find('.' + toggleClass);
  const $backButtons = $mainNav.find('.js-nav-back');

  const $body = $('body');
  const $blinder = $('.nav-blinder');
  var isKeyPress = false;

  $(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
      $blinder.trigger('click');
    }
  });



  var isKeyPress = false;

  document.onkeydown = function(e) {
    if (e.keyCode == 13) {
        isKeyPress = true;
    } else {
      isKeyPress = false;
    }
  }


  isEnterKeyPress = false;
  $(document).keydown(function(e) {
    if (e.keyCode == 13) { // enter key
      isEnterKeyPress = true;
    } else {
      isEnterKeyPress = false;
    }
  });

  // Mouse out or click outside opened header
  $blinder.on('click', () => {
    $mainNav.find('.' + activeClass).removeClass(activeClass);
    $mainNav.find('.' + openClass).removeClass(openClass);
    $body.removeClass('search-open');
    openCloseHeader();
  });
  // Mouse out or click outside opened header
  $blinder.on('mouseenter', () => {
    if (!$body.hasClass('search-open')){
      $blinder.trigger('click');
    }
  });

  $navHamburger.on('click', () => {
      $mainNav.find('> *').addClass(openClass);
      openCloseHeader();
  });

  $navToggles.each((index, toggle) => {
    const $toggle = $(toggle);
    const $subNav = $('> .navbar__nav',$toggle);
    const $subNavItems = $('> .navbar__nav > li',$toggle).filter(function() {
      return $(this).css('display') !== 'none';
    });
    const $navTitle = $('> .nav__title > a', $toggle);
    const isRootLevel = toggle.className.indexOf('l0') > -1;


    $toggle.on('mouseleave', () => {
      $toggle.removeClass(activeClass);
      $toggle.find('.' + openClass).removeClass(openClass);
    });

    $toggle.on('onfocusout', () => {
      $toggle.removeClass(activeClass);
      $toggle.find('.' + openClass).removeClass(openClass);
    });
    $subNavItems.each((index, menuItem) =>{
      // Handle key presses for menuItem
      menuItem.addEventListener('keydown', function (e) {
        // Go to next/previous item if it exists
        // or loop around

        if (e.key === 'Tab') {
          e.preventDefault();
          let nextitem = focusNext($subNavItems, index, 'down');
          $(nextitem).find('a').focus();
        }

        if (e.shiftKey && e.key === 'Tab') {
          e.preventDefault();
          let nextitem = focusNext($subNavItems, index, 'up');
          $(nextitem).find('a').focus();
        }

        // If escape, refocus menu button
        if (e.key === 'Escape') {
          e.preventDefault()
          $toggle.trigger('mouseleave');
          $navTitle.focus();
        }
      }.bind(this))
    });

    function focusNext(items, currentIndex, direction) {
      const itemCount = items.length;

      if (direction === 'up') {
        // Move to the previous item, wrapping around if needed

        return items[(currentIndex - 1 + itemCount) % itemCount];
      } else if (direction === 'down') {
        // Move to the next item, wrapping around if needed

        return items[(currentIndex + 1) % itemCount];
      } else {
        throw new Error('Invalid direction. Use "up" or "down".');
      }
    }

    $toggle.on('mouseenter click', (e) => {
      let isFocusFirst = false;
      if (isEnterKeyPress){
        // Focus + Enter = (handled as a) Click
        // Open menu on first "enter" click (if submenu is present and not open)
        // Follow link on second "enter" click (if submenu is already open)
        if (!$toggle.hasClass(activeClass) && $subNav.length != 0){
          e.preventDefault();
          isFocusFirst = true;

        }
      }
      isEnterKeyPress = false;
      // Closing open menu
      if ($toggle.hasClass(activeClass)) {
        $toggle.removeClass(activeClass);
        $subNav.removeClass(openClass);

      // Opening unopened menu
      } else {

        // Disable current active toggle in same level
        $toggle.find('.' + activeClass).removeClass(activeClass);

        // Close current open submenu in same and deeper levels
        $toggle.find('.' + openClass).removeClass(openClass);

        // Highlight active item and open subnav
        $toggle.addClass(activeClass);
        $subNav.addClass(openClass);
      }

      openCloseHeader();

    });
  });


  $backButtons.each((index, button) => {
    $(button).on('click', e => {
      e.preventDefault();
      $(button).parent().parent().parent().find('.' + toggleClass).removeClass(activeClass);
      $(button).parent().parent().removeClass(openClass);

      openCloseHeader();
    });
  })

  // Toggle header active class
  function openCloseHeader() {
    const activeTogglesLength = $mainNav.find('.' + activeClass).length;
    const openMenusLength = $mainNav.find('.' + openClass).length;

    if(activeTogglesLength > 0 || openMenusLength > 0) {
      $header.addClass(openClass);
      $body.addClass(openClass);
    } else {
      $header.removeClass(openClass);
      $body.removeClass(openClass);
    }
  }

  // Check if mobile
  function isMobile() {
    return window.innerWidth <= 1280; //px
  }
})(jQuery);
